import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import "../css/KuyumcuDataGrid.css";

const ProsetDataGrid = ({
  rows,
  columns,
  pageSize = 7,
  onRowClick,
  noRowsLabel = "Kayıt Bulunamadı",
}) => {
  const centeredColumns = (columns || []).map((col) => ({
    ...col,
    headerAlign: "center",
    align: "center",
  }));

  const isEmpty = !rows || rows.length === 0;

  return (
    <div className="proset-dg-container">
      <DataGrid
        rows={rows}
        columns={centeredColumns}
        pageSize={pageSize}
        onRowClick={onRowClick}
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0
            ? "proset-row-even"
            : "proset-row-odd"
        }
      />

      {isEmpty && (
        <div className="proset-overlay-center">
          {noRowsLabel}
        </div>
      )}
    </div>
  );
};

export default ProsetDataGrid;